/**
 * These methods are shared between the time activity and the calendar events forms.
 * The actual attributes used in the form are different, so they are retrieved before submitting the form
 * in both form component.
 * 
 * What is shared is: The worksite, the worksite phase, the day (calendar event is hidden but set),
 * the times + the fixing process, the user and the title.
 */

 import { mask } from '@titou10/v-mask'
 import TimeDifference from '@spa/apps/trustup-pro-planning-js/components/TimeActivity/_Partials/TimeDifference';
 import SelectUser from '@spa/apps/trustup-pro-base-js/components/_Partials/Selects/User.vue';
 import SelectWorksite from '@spa/apps/trustup-pro-base-js/components/_Partials/Selects/Worksite.vue';
    
 export default {
    components: {
        TimeDifference,
        SelectUser,
        SelectWorksite,
    },

    directives: {
        mask
    },
    
    computed: {
        startsAtDate()
        {
            if ( ! this.form.starts_at ) {
                return null;
            }

            return this.form.day + ' ' + this.form.starts_at + ':00';
        },

        endsAtDate()
        {
            if ( ! this.form.ends_at ) {
                return null;
            }

            return this.form.day + ' ' + this.form.ends_at + ':00';
        }
    },

    methods: {

        setUserById(id)
        {
            this.setUser(
                this.$store.state.models.users.find(user => user.id === id)
            );
        },

        setUser(user)
        {
            this.form.user = user;
        },

        setTimes({starts_at, ends_at})
        {
            this.form.starts_at = starts_at;
            this.form.ends_at = ends_at;

            this.setTimesSilently();

            if ( ! this.keepEditing ) {
                this.edit = false;
            }
        },

        setTimesSilently()
        {
            this.fixTimes();

            if ( this.$refs.timeDifference ) {
                this.$nextTick(() => this.$refs.timeDifference.init());
            }
        },

        fixTimes()
        {
            this.fixTime('starts_at');
            this.fixTime('ends_at');

            this.fixEndsAtIfNecessary();
        },

        fixEndsAtIfNecessary()
        {
            if ( this.$moment(this.startsAtDate).isBefore(this.endsAtDate) ) {
                return;
            }

            this.form.ends_at = this.$moment(this.startsAtDate).add(1, 'hour').format('HH:mm');
            this.fixTimes();
        },

        fixTime(time)
        {
            let [hours, minutes] = this.form[time].split(':');

            if ( typeof minutes == 'undefined' ) {
                minutes = 0;
            }

            if ( parseInt(minutes) > 59 ) {
                minutes = 59;
            }

            if ( parseInt(hours) > 23 ) {
                hours = 23;
            }

            return this.form[time] = hours+':'+minutes;
        },
        
        setWorksiteByUuid(uuid)
        {
            let worksite = this.$store.state.models.worksites.find(worksite => worksite.uuid === uuid);
            this.setWorksite(worksite, true);
            this.onFormChange();
        },
        
        setWorksite(worksite, setRelationships = false)
        {
            console.log('setWorksite', worksite, setRelationships);
            this.form.worksite = worksite;
            this.form.worksite_phase = this.form.trustup_io_task = null; 

            if ( this.form.worksite && this.form.worksite.address && typeof this.form.address !== 'undefined' ) {
                this.form.address = this.form.worksite.address;
            }

            if ( setRelationships && this.form.worksite && this.form.worksite.phases && this.form.worksite.phases.length > 0 ) {
                this.setWorksitePhase(this.form.worksite.phases[0], true);
            }
        },

        setWorksitePhase(phase = null, setRelationships = false)
        {
            if ( phase == null ) {
                phase = this.form.worksite_phase;
            }

            console.log('setWorksitePhase', phase, this.form.worksite_phase, setRelationships);
            this.form.worksite_phase = phase;
            this.form.trustup_io_task = null;

            if ( this.$refs.title ) {
                // this.$refs.title.setTitle(this.form.worksite_phase.title);
            }

            if ( setRelationships && this.form.worksite_phase && this.form.worksite_phase.trustup_io.tasks.tasks && this.form.worksite_phase.trustup_io.tasks.tasks.get().length > 0 ) {
                this.setTrustUpIOTask(this.form.worksite_phase.trustup_io.tasks.tasks.get()[0]);
            }
        },

        setTrustUpIOTask(task)
        {
            if ( task == null ) {
                task = this.form.trustup_io_task;
            }

            console.log('setTrustUpIOTask', task, this.form.trustup_io_task);
            this.form.trustup_io_task = task;
        },

        init()
        {
            if ( this.$refs.timeDifference ) {
                this.$refs.timeDifference.init();
            }
        }

    }
}